/** @format */

import React, { useState } from 'react'
import {
  _$,
  Icon,
  Row,
  Col,
  Select,
  OptionGroup,
  Option,
  FormItem,
  Radio
} from '@king-design/react'
import styled from 'styled-components'
import { cloneDeep } from 'lodash'
import { FormItemLabelToopltip } from 'src/components'
import { IMonitorGraphLineData } from './constants'
import SelectInstance from 'src/components/SelectInstance'
import TagsDialog from './TagsDialog'
import { ProductItem } from 'src/utils/interface'
import variable from 'src/static/styles/var'
import API from 'src/api/ApiDashboard'
import { request } from 'src/utils'
import ProductGroupSelect from 'src/components/ProductGroupSelect'
import { useAsync, useAsyncFn } from 'react-use'
import { isEqual } from 'lodash'

interface EditGraphMetricFormItemProps {
  className?: string
  productList: ProductItem[]
  index: number
  // instanceGroup: GroupItemProps[]
  metricItem: IMonitorGraphLineData
  metricList: IMonitorGraphLineData[]
  handleChangeMetrics: (value: IMonitorGraphLineData[]) => void
  handleLineCount: () => boolean
}

export const aggregator_menu = {
  max: _$('最大值'),
  min: _$('最小值'),
  average: _$('平均值'),
  sum: _$('求和'),
  '': _$('不聚合')
}

const EditGraphMetricFormItem: React.FC<EditGraphMetricFormItemProps> = ({
  className,
  productList,
  index,
  metricItem,
  metricList,
  handleChangeMetrics,
  handleLineCount
}) => {
  const [formValues, setFormValues] = useState<IMonitorGraphLineData>(metricItem)
  const [dimension, setDimension] = useState<number>(0)

  // 临时储存metricList,解决初始化isDimension问题
  const changvalues = (index, values) => {
    const cloneMetrics = cloneDeep(metricList)
    cloneMetrics[index] = { ...cloneMetrics[index], ...values }
    handleChangeMetrics(cloneMetrics)
    const params = {
      ...formValues,
      ...values
    }
    const { metricKey, metricTags, instances } = values
    if (metricKey || metricTags || instances) {
      unmatch_fetch(params)
    }
    // 修改form
    setFormValues(params)
  }

  // 获取产品线下的监控项
  const { value: monitorList } = useAsync(async () => {
    if (formValues.productType !== 99999) {
      const result = await request(API.DescribeDashboardMetrics, {
        method: 'post',
        data: {
          ProductType: formValues.productType
        }
      })
      if (result.code === 'Success') {
        const metricsGroup = []
        const findDimension = result.data?.metricList.find(
          item => item.metricKey === formValues.metricKey
        )?.isDimension
        setDimension(findDimension || 0)
        result.data?.metricList.forEach(
          ({ application, metricKey, metricName, units, delay, isDimension }) => {
            const key = application || _$('其它')
            const findIndex = metricsGroup.findIndex(({ app }) => app === key)
            if (findIndex >= 0) {
              metricsGroup[findIndex].children.push({
                metricKey,
                metricName,
                units,
                delay,
                isDimension
              })
            } else {
              metricsGroup.push({
                app: key,
                children: [{ metricKey, metricName, units, delay, isDimension }]
              })
            }
          }
        )
        return metricsGroup
      } else {
        return []
      }
    }
  }, [formValues.productType])

  // 维度列表
  const { value: tags } = useAsync(async () => {
    const { productType, metricKey, instances } = formValues
    let result_tags = []
    if (productType !== 99999 && metricKey && instances?.length && dimension === 1) {
      const result = await request(API.getDashboardMetricTags, {
        method: 'post',
        data: {
          ProductType: productType,
          MetricKey: metricKey,
          Instances: instances.map(item => item.instanceId)
        }
      })
      result_tags = result?.data?.metricTags || []
    }
    return result_tags
  }, [formValues.productType, formValues.metricKey, formValues.instances, dimension])

  // 验证资源跟维度是否匹配
  const [{ value: unmatch_instances }, unmatch_fetch] = useAsyncFn(
    async params => {
      const { productType, metricKey, instances, metricTags } = params
      if (
        productType !== 99999 &&
        metricKey &&
        instances?.length &&
        metricTags?.length &&
        dimension === 1
      ) {
        const result = await request(API.getDashboardInstanceMetricTags, {
          method: 'post',
          data: {
            ProductType: productType,
            MetricKey: metricKey,
            Instances: instances.map(item => item.instanceId),
            MetricTags: metricTags
          }
        })
        return result?.data?.instances || []
      } else {
        return []
      }
    },
    [dimension]
  )

  // 复制metric
  const copyMetric = metric => {
    if (handleLineCount()) {
      const copy = cloneDeep(metric)
      const cloneMetrics = cloneDeep(metricList)
      copy.graphMetricId = Math.round(-1000 * Math.random())
      cloneMetrics.push(copy)
      handleChangeMetrics(cloneMetrics)
    }
  }

  // 删除metric
  const removeMetric = index => {
    if (metricList?.length) {
      const cloneMetrics = cloneDeep(metricList)
      cloneMetrics.splice(index, 1)
      handleChangeMetrics(cloneMetrics)
    }
  }

  // 移动metric
  const moveMetric = (index: number, direction: 'up' | 'down') => {
    const cloneMetrics = cloneDeep(metricList)
    const copyItem = cloneDeep(metricList[index])
    cloneMetrics.splice(index, 1)
    if (direction === 'up') {
      cloneMetrics.splice(index - 1, 0, copyItem)
    } else {
      cloneMetrics.splice(index + 1, 0, copyItem)
    }
    handleChangeMetrics(cloneMetrics)
  }

  return (
    <span className={className}>
      <FormItem
        slotLabel={
          <FormItemLabelToopltip
            label={_$('监控项')}
            tips="请选择产品类型和监控项，定义展示在图表中的数据"
          />
        }
      >
        <Row gutter="16">
          <Col span="12">
            <FormItem
              hideLabel
              value={formValues.productType}
              rules={{
                required: true
              }}
            >
              {productList?.length ? (
                <ProductGroupSelect
                  value={formValues.productType}
                  width={300}
                  placeholder={_$('请选择产品类型')}
                  productList={productList}
                  onChange={value => {
                    if (formValues.productType !== value) {
                      changvalues(index, {
                        productType: value,
                        metricKey: '',
                        metricName: '',
                        units: '',
                        delay: 0,
                        instances: [],
                        metricTags: []
                      })
                    }
                  }}
                />
              ) : null}
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem
              hideLabel
              value={formValues.metricKey}
              rules={{
                required: true
              }}
            >
              <Select
                width={300}
                card
                value={formValues.metricKey}
                filterable
                placeholder={_$('选择监控项')}
                onChangeValue={value => {
                  if (value) {
                    let find
                    for (const item of monitorList) {
                      const { children } = item
                      find = children.find(({ metricKey }) => `${metricKey}` === value)
                      if (find) break
                    }
                    if (find) {
                      changvalues(index, {
                        metricKey: find?.metricKey,
                        metricName: find?.metricName,
                        units: find?.units || '',
                        delay: find?.delay,
                        metricTags: []
                      })
                      setDimension(find.isDimension || 0)
                    }
                  }
                }}
              >
                {monitorList?.length
                  ? monitorList.map(({ app, children }) => (
                      <OptionGroup label={app} key={app}>
                        {children.map(item => (
                          <Option key={`${item.metricKey}`} value={`${item.metricKey}`}>
                            {item.metricName}
                          </Option>
                        ))}
                      </OptionGroup>
                    ))
                  : null}
              </Select>
            </FormItem>
          </Col>
        </Row>
      </FormItem>
      {formValues?.productType !== undefined && formValues.productType !== null ? (
        <FormItem label={_$('资源')} value={formValues.instances || []} rules={{ required: true }}>
          <SelectInstance
            productType={formValues.productType + ''}
            allInstance={false}
            projectDimens={false}
            instanceGroup={false}
            isGroupFilter={true}
            isRegionFilter={true}
            defaultRadioValue={3}
            defaultInstance={formValues.instances || []}
            batchSearch={true}
            instanceMaxLength={1000}
            onChange={(redio, value) => {
              if (redio === 3) {
                const equal = isEqual(value, formValues.instances)
                changvalues(index, {
                  instances: value,
                  metricTags: equal ? formValues.metricTags : []
                })
              }
            }}
          />
        </FormItem>
      ) : null}

      {/* 维度 */}
      {tags?.length ? (
        <FormItem
          value={formValues.metricTags}
          rules={{ required: true }}
          slotLabel={
            <FormItemLabelToopltip
              label={_$('维度')}
              tips="请先选择实例，再选择维度，维度只有一个时，默认选择，维度存在多个时，可选择多个维度进行展示，不选时默认选择全部维度。"
            />
          }
        >
          <TagsDialog
            values={formValues.metricTags}
            tags={tags}
            unmatch_instances={unmatch_instances}
            onChange={values => {
              changvalues(index, {
                metricTags: values
              })
            }}
          />
        </FormItem>
      ) : null}

      {/* 周期聚合方式 */}
      <FormItem
        slotLabel={
          <FormItemLabelToopltip
            label={_$('周期聚合方式')}
            tips="对每个周期内数据进行分组聚合展示。"
          />
        }
        className="aggregator-radio"
        value={formValues.aggregator || 'max'}
        rules={{ required: true }}
        messages={{
          required: _$('请选择周期聚合方式')
        }}
      >
        {Object.keys(aggregator_menu).map(key => {
          if (key === '') return ''
          const name = aggregator_menu[key]
          return (
            <Radio
              key={key}
              name="aggregator"
              trueValue={key}
              value={formValues.aggregator || 'max'}
              onChangeValue={value => {
                changvalues(index, {
                  aggregator: value
                })
              }}
            >
              {_$(name)}
            </Radio>
          )
        })}
      </FormItem>

      {/* 实例聚合方式 */}
      {formValues.instances?.length > 1 ? (
        <FormItem
          slotLabel={
            <FormItemLabelToopltip
              label={_$('实例聚合方式')}
              tips="仅选择2个及以上实例时可选该项。若选择聚合方式，取所选多个实例中的最大值/最小值/平均值/求和值展示。若选择不聚合，展示各实例数据。"
            />
          }
          className="aggregator-radio"
          value={formValues.resourceAggregator}
          messages={{
            required: _$('请选择实例聚合方式')
          }}
        >
          {Object.keys(aggregator_menu).map(key => {
            const name = aggregator_menu[key]
            return (
              <Radio
                key={key}
                name="resourceAggregator"
                trueValue={key}
                value={formValues.resourceAggregator}
                onChangeValue={value => {
                  changvalues(index, {
                    resourceAggregator: value || '',
                    tagsAggregator: ''
                  })
                }}
              >
                {name}
              </Radio>
            )
          })}
        </FormItem>
      ) : null}
      {/* 维度聚合方式 */}
      {dimension === 1 && formValues.metricTags?.length && formValues.resourceAggregator === '' ? (
        <FormItem
          slotLabel={
            <FormItemLabelToopltip
              label={_$('维度聚合方式')}
              tips="仅监控项含维度时可选该项。若选择聚合方式，按实例取维度值中的最大值/最小值/平均值/求和值展示。若选择不聚合，展示各维度数据。"
            />
          }
          className="aggregator-radio"
          value={formValues.tagsAggregator}
          messages={{
            required: _$('请选择维度聚合方式')
          }}
        >
          {Object.keys(aggregator_menu).map(key => {
            const name = aggregator_menu[key]
            return (
              <Radio
                key={key}
                name="tagsAggregator"
                trueValue={key}
                value={formValues.tagsAggregator}
                onChangeValue={value => {
                  changvalues(index, {
                    tagsAggregator: value || ''
                  })
                }}
              >
                {name}
              </Radio>
            )
          })}
        </FormItem>
      ) : null}
      <div className="icon-list">
        <Icon
          className="ion-ios-copy"
          size={18}
          onClick={() => {
            copyMetric(metricItem)
          }}
        />
        {metricList.length > 1 ? (
          <Icon
            className="ion-android-delete"
            size={18}
            onClick={() => {
              removeMetric(index)
            }}
          />
        ) : null}
        {metricList.length > 1 && index !== 0 ? (
          <Icon
            className="ion-arrow-up-a"
            size={18}
            onClick={() => {
              moveMetric(index, 'up')
            }}
          />
        ) : null}
        {metricList.length > 1 && index !== metricList.length - 1 ? (
          <Icon
            className="ion-arrow-down-a"
            size={18}
            onClick={() => {
              moveMetric(index, 'down')
            }}
          />
        ) : null}
      </div>
    </span>
  )
}

export default styled(EditGraphMetricFormItem)`
  width: 100%;
  display: block;
  margin-bottom: 8px;
  padding-top: 24px;
  border-top: 1px solid #e5e5e5;
  position: relative;
  /* & > .k-form-item:first-child {
      margin-bottom: 8px;
    } */
  .k-form-content {
    width: 100%;
  }
  .k-row {
    width: 630px;
  }
  .k-form-item {
    .tips {
      margin: 0;
      color: #999;
    }
    & > .k-form-label {
      width: 120px;
    }
  }
  .icon-list {
    position: absolute;
    height: 30px;
    top: 26px;
    right: 16px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .k-icon {
      margin-left: 8px;
      cursor: pointer;
      transition: all ease-in-out 0.2s;
      &:hover {
        color: ${variable.primaryColor};
      }
    }
  }

  .aggregator-radio {
    .k-form-content {
      margin-top: 2px;
      .k-radio {
        margin-right: 8px;
      }
    }
  }
`
